import { RECEIVE_SITE_INFO } from '../actions'

export const DEFAULT_SITE_INFO = 'defaultSiteInfo'

let defaultSiteInfo = {
        name: '',
        description: '',
    }

let defaultState = {
    [DEFAULT_SITE_INFO]: defaultSiteInfo
}

export default function siteinfo(state = defaultState, action) {
    switch(action.type) {
        case RECEIVE_SITE_INFO:
            const { siteInfo } = action.payload

            return Object.assign({}, state, {
                siteInfo: siteInfo
            });

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/siteinfo.js